(function () {
    function showAlert(alert, options) {
        options = options || {};

        var alertElement;
        if (options.preventFadeOut) {
            var templateWithCloseButton =
                "<div class='toast bottom " + alert.alertClass + "' data-autohide='false'>"
                +     "<button type='button' class='text-white mr-1 mt-1 close' data-dismiss='toast' aria-label='Close'>"
                +         "<span aria-hidden='true'>&times;</span>"
                +     "</button>"
                +     "<div class='toast-body'>"
                +         alert.message
                +     "</div>"
                + " </div>";
            alertElement = $(templateWithCloseButton);
        } else {
            var template =
                "<div class='toast bottom " + alert.alertClass + "' data-delay='6000'>"
                +     "<div class='toast-body'>"
                +         alert.message
                +     "</div>"
                + "</div>";
            alertElement = $(template);
            window.setTimeout(function () {
                alertElement.remove();
            }, 6000);
        }
        $(".alert-container").append(alertElement);
        alertElement.on('hidden.bs.toast', function () {
            if (options.onClose && typeof options.onClose === "function") {
                options.onClose();
            }
            alertElement.remove();
        });

        alertElement.toast('show');
    }

    function success(message, options) {
        showAlert({ alertClass: "success", message: message || $(".alert-container").data('default-success') }, options);
    }

    function info(message, options) {
        showAlert({ alertClass: "info", message: message }, options);
    }

    function warning(message, options) {
        showAlert({ alertClass: "warning", message: message }, options);
    }

    function error(message, options) {
        showAlert({ alertClass: "error", message: message || $(".alert-container").data('default-error') }, options);
    }

    var alertService = {
        showAlert: showAlert,
        success: success,
        info: info,
        warning: warning,
        error: error
    };

    window.alerts = alertService;
})();
